/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDataExportDestinationsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListDataExportDestinationsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListDataExportDestinationsSecurity = {
  option1?: ListDataExportDestinationsSecurityOption1 | undefined;
  option2?: ListDataExportDestinationsSecurityOption2 | undefined;
};

export type ListDataExportDestinationsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListDataExportDestinationsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListDataExportDestinationsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListDataExportDestinationsSecurityOption1$Outbound,
    ListDataExportDestinationsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listDataExportDestinationsSecurityOption1ToJSON(
  listDataExportDestinationsSecurityOption1:
    ListDataExportDestinationsSecurityOption1,
): string {
  return JSON.stringify(
    ListDataExportDestinationsSecurityOption1$outboundSchema.parse(
      listDataExportDestinationsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListDataExportDestinationsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListDataExportDestinationsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListDataExportDestinationsSecurityOption2$Outbound,
    ListDataExportDestinationsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listDataExportDestinationsSecurityOption2ToJSON(
  listDataExportDestinationsSecurityOption2:
    ListDataExportDestinationsSecurityOption2,
): string {
  return JSON.stringify(
    ListDataExportDestinationsSecurityOption2$outboundSchema.parse(
      listDataExportDestinationsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListDataExportDestinationsSecurity$Outbound = {
  Option1?: ListDataExportDestinationsSecurityOption1$Outbound | undefined;
  Option2?: ListDataExportDestinationsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListDataExportDestinationsSecurity$outboundSchema: z.ZodMiniType<
  ListDataExportDestinationsSecurity$Outbound,
  ListDataExportDestinationsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListDataExportDestinationsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListDataExportDestinationsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listDataExportDestinationsSecurityToJSON(
  listDataExportDestinationsSecurity: ListDataExportDestinationsSecurity,
): string {
  return JSON.stringify(
    ListDataExportDestinationsSecurity$outboundSchema.parse(
      listDataExportDestinationsSecurity,
    ),
  );
}

/** @internal */
export type ListDataExportDestinationsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListDataExportDestinationsRequest$outboundSchema: z.ZodMiniType<
  ListDataExportDestinationsRequest$Outbound,
  ListDataExportDestinationsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listDataExportDestinationsRequestToJSON(
  listDataExportDestinationsRequest: ListDataExportDestinationsRequest,
): string {
  return JSON.stringify(
    ListDataExportDestinationsRequest$outboundSchema.parse(
      listDataExportDestinationsRequest,
    ),
  );
}
